import React, { ReactNode } from "react";
import style from "./index.module.scss";
interface GeneralCardProps {
    bgColor?: string; //背景图片
    name: string; //卡片名
    icon: string; //卡片图标
    count: number; //卡片主要次数数据
    ratio?: number; // 参与率
    children?: ReactNode;
}

export default function CardInfo({
    name,
    icon,
    count,
    bgColor,
    ratio,
    children
}: GeneralCardProps) {
    return (
        <div
            className={style.cardInfo}
            style={{ backgroundColor: `${bgColor}` }}>
            {/* <img className={style.bgImg} src={bgImg} alt="" /> */}
            <img className={style.icon} src={icon} alt="" />
            <div>
                <p className={style.name}>{name}</p>
                <p>
                    {" "}
                    <span className={style.count}>{count}</span>&nbsp;&nbsp;次
                </p>
                {(ratio || ratio === 0) && (
                    <p className={style.ratio}>参与率&nbsp;{ratio}%</p>
                )}
            </div>
            {children}
        </div>
    );
}
